export default __webpack_public_path__ + "static/char-16-anr-e7551a17042c88cc029f9df661db1820.gif";